import React, { useEffect } from 'react'
import { styles } from '../../../../styles/tailwind-config'
import useNav from '../../../../hooks/useNav'
import { Label } from '../../../../components/ui/label'
import { Select, SelectTrigger, SelectValue, SelectContent, SelectGroup, SelectItem } from '../../../../components/ui/select'
import { useTranslation } from 'react-i18next'
import { Trans, useLingui } from '@lingui/react/macro'

const Main = () => {
    const { t } = useLingui()
    const { i18n } = useTranslation()

    const { setNav, nav } = useNav()
    useEffect(()=>{
        setNav({...nav, title:t`Instellingen`})
    }, [])

    const handleChangeLanguage = (language:string) => {
        i18n.changeLanguage(language)
    }

  return (
    <div className='p-4 flex flex-col gap-4'>
        <h1 className={styles.h1}><Trans>Instellingen</Trans></h1>
        <div>
            <Label><Trans>Wijzig taalinstellingen</Trans></Label>
            <Select value={i18n.language} onValueChange={(v)=>{handleChangeLanguage(v)}}>
                <SelectTrigger><SelectValue /></SelectTrigger>
                <SelectContent><SelectGroup>
                    <SelectItem value="nl">Nederlands</SelectItem>
                    <SelectItem value="en">English</SelectItem>
                    <SelectItem value="fr">Français</SelectItem>
                </SelectGroup></SelectContent>
            </Select>
        </div>
    </div>
  )
}

export default Main